import { MouseEventHandler, ReactNode } from "react";

export enum ButtonVariant {
  DISABLED = "DISABLED",
  DEFAULT = "DEFAULT",
  DANGER = "DANGER",
}

export type DropdownOption = {
  label: ReactNode;
  onClick: MouseEventHandler<HTMLLIElement>;
};
